import { useQuery } from '@tanstack/react-query';
import { StatusCode } from '@hungryroot/rest';
import {
  getExperiments,
  type GetExperimentsParams,
} from '@hungryroot/rest/api/v2/experiments/get';

const DEFAULT_PARAMS: GetExperimentsParams = {
  limit: 1000,
  offset: 0,
};

type QueryOptions = {
  enabled?: boolean;
};

export async function fetchExperimentDefinitions(
  params: GetExperimentsParams = {}
) {
  const res = await getExperiments({
    ...DEFAULT_PARAMS,
    ...params,
  });
  const { status } = res;
  if (
    status < StatusCode.SuccessOK ||
    status > StatusCode.RedirectMultipleChoices
  ) {
    throw res.data;
  }

  return res.data;
}

export function experimentDefinitionsKey(params: GetExperimentsParams = {}) {
  return ['experiment-definitions', params];
}

export function useExperimentDefinitions(
  params: GetExperimentsParams = {},
  options: QueryOptions = {}
) {
  return useQuery({
    queryKey: experimentDefinitionsKey({
      ...DEFAULT_PARAMS,
      ...params,
    }),
    queryFn: async () => {
      return await fetchExperimentDefinitions(params);
    },
    ...options,
    staleTime: 5 * 60 * 1000,
  });
}
